// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../services/api";

export default function ProtectedRoute({ children, allow = [] }) {
  const [checking, setChecking] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const check = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setOk(false);
        setChecking(false);
        return;
      }
      try {
        const { data } = await auth.validate().catch(() => ({}));
        console.log("🔐 validate response →", data);
        if (!data?.valid) throw new Error("invalid");
        localStorage.setItem("rol", data.user?.rol || "");
        if (data.user?.empleado_id) {
          localStorage.setItem("empleado_id", data.user.empleado_id);
        }
        // Si se especifican roles permitidos, valida
        if (allow.length && !allow.includes(data.user?.rol)) {
          setOk(false);
        } else {
          setOk(true);
        }
      } catch {
        setOk(false);
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [allow]);

  if (checking) return null;
  if (!ok) return <Navigate to="/login" replace />;
  return children;
}
